import { useMemo } from 'react'
import type { UnitOfMeasure } from '@ztechapps/common.contract'

export type UseUomConversionFactorResult = {
  calculatedFactor: number | null
  isCrossCategory: boolean
}

export const useUomConversionFactor = (
  baseUom: Pick<UnitOfMeasure, '_id' | 'category' | 'conversionFactor'> | null | undefined,
  contextUom: Pick<UnitOfMeasure, '_id' | 'category' | 'conversionFactor'> | null | undefined
): UseUomConversionFactorResult => {
  return useMemo(() => {
    if (!baseUom || !contextUom) {
      return { calculatedFactor: null, isCrossCategory: false }
    }

    if (baseUom._id === contextUom._id) {
      return { calculatedFactor: 1, isCrossCategory: false }
    }

    if (baseUom.category !== contextUom.category) {
      return { calculatedFactor: null, isCrossCategory: true }
    }

    if (!baseUom.conversionFactor) {
      return { calculatedFactor: null, isCrossCategory: false }
    }

    const factor = contextUom.conversionFactor / baseUom.conversionFactor
    return { calculatedFactor: factor, isCrossCategory: false }
  }, [baseUom, contextUom])
}
